import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useSeminarsSessionsQuery = getWrappedUseQuery(
  KEYS.GET_SEMINAR_SESSIONS,
  apiClient.ForumSeminarSessions.getAll,
);
